<template>
  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/send_activity_list')">赠送活动管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size="small"
          :model="filters"
        >
          <el-form-item label="活动名称">
            <el-input
              style="width:300px"
              v-model="filters.infoName"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="礼包名称">
            <el-input
              style="width:300px"
              v-model="filters.goodName"
              placeholder="请输入礼包名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-form-item prop="beginTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.beginTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="活动类型">
            <el-select
              v-model="filters.infoType"
              clearable
            >
              <el-option
                label="满金额赠送"
                value="1"
              ></el-option>
              <el-option
                label="满数量赠送"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动状态">
            <el-select
              v-model="filters.status"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="上架中"
                value="2"
              ></el-option>
              <el-option
                label="下架中"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('80011991')"
              style="margin-left:10px"
              @click="addOrUpOne"
              type="primary"
              size="small"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div>-->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name="objectSpanMethod"
        >
          <el-table-column
            prop="info_name"
            label="活动名称"
          ></el-table-column>

          <el-table-column
            prop="info_type"
            label="活动类型"
            width="300"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.info_type == 1">
                满金额赠送：满{{scope.row.info_money}}元赠送一个大礼包
                <br />
                {{scope.row.good_name}}
                <br />
                <img
                  :src="scope.row.good_pic"
                  style="width:50px;height:50px"
                />
              </div>
              <div v-if="scope.row.info_type == 2">
                满数量赠送：满{{scope.row.info_num}}件赠送一个同款商品
                <br />参与商品：{{scope.row.good_id_name}}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="send_num"
            label="赠送明细"
          >
            <template slot-scope="scope">
              <el-button
                @click="showDetailInfos(scope.row)"
                type="text"
                size="small"
              >查看</el-button>
              <br />
              <el-button
                v-if="scope.row.send_num > 0"
                @click="excelOut(scope.row)"
                type="text"
                size="small"
              >导出</el-button>
            </template>
          </el-table-column>

          <el-table-column
            prop="send_num"
            width="300"
            label="剩余数量"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.info_type == 1">
                {{scope.row.send_total - scope.row.send_num}}
              </div>
              <div v-if="scope.row.info_type == 2">
                <div v-for="o in scope.row.send_num_list1" :key="o.id">
                  <span style="width:200px;display: inline-block;">{{o.goodName}}</span>{{o.value-o.sendNum}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time_"
            label="创建时间"
          ></el-table-column>

          <el-table-column
            prop="begin_time_"
            label="活动开始时间"
          ></el-table-column>
          <el-table-column
            prop="end_time_"
            label="活动结束时间"
          ></el-table-column>

          <el-table-column
            prop="status"
            label="活动状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2 && scope.row.begin_time <= scope.row.now_time && scope.row.end_time >= scope.row.now_time"
                disable-transitions
              >上架中</el-tag>
              <el-tag
                v-if="scope.row.status == 2 && scope.row.begin_time > scope.row.now_time"
                disable-transitions
                type="info"
              >上架中-活动未开始</el-tag>
              <el-tag
                v-if="scope.row.status == 2 && scope.row.end_time < scope.row.now_time"
                disable-transitions
                type="warning"
              >上架中-活动已结束</el-tag>
              <el-tag
                v-if="scope.row.status == 3"
                type="danger"
                disable-transitions
              >下架中</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button v-if="hasPower('80011991')"
                @click="addOrUpOne(scope.row)"
                type="text"
                size="small"
              >修改</el-button>
              <template v-if="hasPower('80011991') && scope.row.first_status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >上架</el-button>
              </template>
              <template v-if="hasPower('80011991') && scope.row.first_status == 2">
                <el-button
                  @click="upHouseStatus(scope.row,3)"
                  type="text"
                  size="small"
                >下架</el-button>
              </template>

              <el-button v-if="hasPower('80011991')"
                @click="upHouseStatus(scope.row,4)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count="total_page"
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="username"
          label="代理信息"
        >
          <template slot-scope="scope">
            {{scope.row.username}}({{scope.row.telephone}})
          </template>
        </el-table-column>

        <el-table-column
          prop="order_code"
          label="订单号"
        >
        </el-table-column>

        <el-table-column
          prop="create_time"
          label="下单时间"
        >
        </el-table-column>

        <el-table-column
          prop="good_name"
          label="赠送商品"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="赠送数量"
        >
        </el-table-column>

        <el-table-column
          label="列表图片"
          prop="good_pic"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.good_pic"
              style="width:50px;"
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "money_out_list",
  created() {},

  data() {
    return {
      listLoading: false,
      picList: [],
      filters: {
        infoType: null,
        status: null,
        infoName: null,
        beginTime: null,
        goodName: null,
        endTime: null
      },
      detailListLoading: false,
      page_num: 1,
      tableDetailData: null,
      keywords: "",
      tableData: [],
      total_num: 0,
      totalMoney: 0,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      subListVisible: false,
      activityId: null,
      page_num1: 1,
      tableData1: [],
      total_num1: 0,
      total_page1: 0,
      page_size1: 10
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  activated() {
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    excelOut(row) {
      var that = this;
      var url =
        "/manager/user/pc/send_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&acName=" + row.info_name;
      url = url + "&activityId=" + row.id;

      top.location.href = url;
    },
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.activityId = row.id;
      this.searchDetail(this.askRoleType);
    },
    addOrUpOne(row) {
      this.$router.push({
        path: "/addOrEditSendActivity",
        query: { activity: row }
      });
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("下架后，APP将无法参与该活动", "确定下架吗?", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 3
            };
            API.do_up_send_ac(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "下架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm(
          "上架后，APP端将按照时间顺序使用最新的活动规则参与活动",
          "确定上架吗?",
          { type: "info" }
        )
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 2
            };
            API.do_up_send_ac(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 4) {
        let that = this;
        this.$confirm("删除后，前后台都看不到此活动", "确定删除吗？", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.del_send_ac(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.infoName) {
        params.infoName = that.filters.infoName;
      }
      if (that.filters.goodName) {
        params.goodName = that.filters.goodName;
      }
      if (that.filters.beginTime) {
        params.beginTime = that.filters.beginTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      that.listLoading = true;
      API.send_ac_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.totalMoney = result.result.data;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time_ = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].begin_time_ = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].begin_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].end_time_ = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].end_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].now_time = new Date().getTime();
                  if (result.result.list[i].info_type == 2) {
                    result.result.list[i].send_num_list1 =  result.result.list[i].send_num_list == null ? [] : JSON.parse(result.result.list[i].send_num_list);
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChange1(val) {
      this.searchDetail();
    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        activityId: that.activityId,
        pageNum: that.page_num1,
        pageSize: that.page_size1
      };
      that.detailListLoading = true;
      API.send_order_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/send_activity_list.vue